<template>
  <v-form ref="form0">
    <div class="d-flex flex-column ga-6">
      <span class="text-heading text-primary text-bold">Intake vragenlijst</span>

      <div class="d-flex flex-column ga-10 mt-6">
        <span class="text-normal text-primary"
          >Wat goed dat jij je hebt aangemeld voor het instapprogramma van Get
          Fit Girl. Om aan de slag te kunnen gaan, hebben we wat gegevens van je
          nodig.</span
        >
        <span class="text-normal text-primary"
          ><span class="text-bold">Let op!</span> De vragenlijst dien je in één
          keer in te vullen; tussentijds opslaan is niet mogelijk. Daarnaast
          willen we je erop attenderen dat je abonnement doorloopt, ook als je
          deze vragen niet hebt ingevuld.</span
        >
      </div>
    </div>
  </v-form>
</template>

<script></script>
